// extracted by mini-css-extract-plugin
module.exports = {"gradient":"styles_gradient__OtQet"};